module.exports = __webpack_public_path__ + "static/media/logos_mobile.e4ef1bb2.webp";